import React from 'react';
import { ControlLabel, FormControl } from 'react-bootstrap';
import { orderDataProblemDescriptionChanged } from '../actions/instuctionActions';
import { connect } from 'react-redux';

function InstructionGeneratorHybridFields(props) {
  const updateOrderDataProblemDescription = (value) => { props.dispatch(orderDataProblemDescriptionChanged(value)); };

  return (<div>
    <ControlLabel>Problem description</ControlLabel>
    <FormControl
      disabled={false}
      componentClass="textarea"
      value={props.orderData.problemDescription}
      onChange={(ev) => updateOrderDataProblemDescription(ev.target.value)}/>
  </div>);
}

function mapStateToProps ({ instructionsReducer }) {
  return {
    ...instructionsReducer
  };
}

const mapDispatchToProps = (dispatch) => {
  return { dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(InstructionGeneratorHybridFields);
